<div class="navbar bg-base-100/90 border-base-200 dark:border-base-content/10 sticky top-0 z-50 border-b backdrop-blur-md">
	<!-- Navbar Start -->
	<div class="navbar-start">
		<div class="dropdown lg:hidden">
			<div
				tabindex="0"
				role="button"
				class="btn btn-ghost lg:hidden"
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					class="h-5 w-5"
					fill="none"
					viewBox="0 0 24 24"
					stroke="currentColor"
				>
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
						d="M4 6h16M4 12h8m-8 6h16"
					/>
				</svg>
			</div>
			<ul
				tabindex="0"
				class="menu menu-sm dropdown-content bg-base-100 rounded-box z-[1] mt-3 w-52 p-2 shadow"
			>
				<li>
					<a
						[routerLink]="'/'"
						fragment="features"
						[translate]
						[inputLanguage]="'fr'"
						>Fonctionnalités</a
					>
				</li>
				<li>
					@if (connectedUsers().length > 0) {
						<ul class="p-2">
							<li>
								<a
									[routerLink]="'/host/dashboard'"
									[translate]
									[inputLanguage]="'fr'"
									>Tableau de bord</a
								>
							</li>
							<li>
								<button
									(click)="logout()"
									[translate]
									[inputLanguage]="'fr'"
								>
									Se déconnecter
								</button>
							</li>
						</ul>
					} @else {
						<ul class="p-2">
							<li>
								<a
									[routerLink]="'/auth/login'"
									[routerLinkActive]="'active'"
									[translate]
									[inputLanguage]="'fr'"
									>Connexion</a
								>
							</li>
							<li>
								<a
									[routerLink]="'/auth/register'"
									[routerLinkActive]="'active'"
									[translate]
									[inputLanguage]="'fr'"
									>Inscription</a
								>
							</li>
						</ul>
					}
				</li>
			</ul>
		</div>
		<a
			class="btn btn-ghost gap-2 px-2 text-xl"
			[routerLink]="'/'"
		>
			<svg
				class="text-primary h-6 w-6"
				fill="currentColor"
				viewBox="0 0 24 24"
			>
				<path d="M6 10.3a6 2.2 0 0 0 12 0v3.4a6 2.2 0 0 1-12 0v-3.4Z" />
				<path d="M12 5 2.5 9.5 12 14l9.5-4.5L12 5Z" />
				<circle
					cx="21"
					cy="9.5"
					r="1.1"
				/>
				<path
					d="M21 9.7v4"
					stroke="currentColor"
					stroke-width="1.3"
					stroke-linecap="round"
					fill="none"
				/>
			</svg>
			<span class="from-primary to-secondary bg-gradient-to-r bg-clip-text font-bold text-transparent">GadzApp</span>
		</a>
	</div>

	<!-- Navbar Center (Desktop) -->
	<div class="navbar-center hidden lg:flex">
		<ul class="menu menu-horizontal gap-1 px-1">
			<li>
				<a
					[routerLink]="'/'"
					fragment="features"
					class="font-medium"
					[translate]
					[inputLanguage]="'fr'"
					>Fonctionnalités</a
				>
			</li>
		</ul>
	</div>

	<!-- Navbar End -->
	<div class="navbar-end gap-2">
		@if (connectedUsers().length > 0) {
			<a
				[routerLink]="'/host/dashboard'"
				class="btn btn-primary btn-sm hidden md:flex"
				[translate]
				[inputLanguage]="'fr'"
				>Tableau de bord</a
			>
			<div class="dropdown dropdown-end">
				<div
					tabindex="0"
					role="button"
					class="btn btn-ghost btn-circle avatar placeholder"
				>
					@let currentUserAvatar_ = currentUserAvatar();
					@if (currentUserAvatar_) {
						<div class="w-10 rounded-full">
							<img
								[src]="currentUserAvatar_"
								alt="Profile"
							/>
						</div>
					} @else {
						<div class="bg-neutral text-neutral-content flex w-10 items-center justify-center rounded-full">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 24 24"
								fill="currentColor"
								class="h-6 w-6"
							>
								<path
									fill-rule="evenodd"
									d="M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z"
									clip-rule="evenodd"
								/>
							</svg>
						</div>
					}
				</div>
				<ul
					tabindex="0"
					class="menu menu-sm dropdown-content bg-base-100 rounded-box z-[1] mt-3 w-52 p-2 shadow"
				>
					<li>
						<a
							[routerLink]="'/host/dashboard'"
							[translate]
							[inputLanguage]="'fr'"
							>Tableau de bord</a
						>
					</li>
					<li>
						<button
							(click)="logout()"
							[translate]
							[inputLanguage]="'fr'"
						>
							Se déconnecter
						</button>
					</li>
				</ul>
			</div>
		} @else {
			<a
				class="btn btn-ghost btn-sm hidden md:flex"
				[routerLink]="'/auth/login'"
				[translate]
				[inputLanguage]="'fr'"
				>Connexion</a
			>
			<a
				class="btn btn-primary btn-sm"
				[routerLink]="'/auth/register'"
				[translate]
				[inputLanguage]="'fr'"
				>Inscription</a
			>
		}
	</div>
</div>
